export default __webpack_public_path__ + "static/media/treble-clef.91aa97a0.svg";